"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesMap = void 0;
var MessageProps_1 = require("./MessageProps");
var styles = require("./Message.css");
exports.stylesMap = new Map([
    [MessageProps_1.MessageType.INFO, styles.info],
    [MessageProps_1.MessageType.SUCCESS, styles.success],
    [MessageProps_1.MessageType.ERROR, styles.error],
    [MessageProps_1.MessageType.HELLO, styles.hello],
    [MessageProps_1.MessageType.HELLOL, styles.helloL],
    [MessageProps_1.MessageType.ERRORL, styles.errorL],
]);
//# sourceMappingURL=MessageStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Message/MessageStylesMaps.js
// module id = 1205
// module chunks = 8